module.exports = __webpack_public_path__ + "img/dashboard.73634aee.svg";